import React, { useState, useEffect } from "react";

import Header from "../Header";

import Sidebar from "../Sidebar";

import Footer from "../Footer";

import { useParams, Link } from "react-router-dom";

import { isMobile } from "react-device-detect";

import Setup from "../Setup";

import Statistic from "./Statistic";

import { useSelector } from "react-redux";

import axios from "axios";

const Home = () => {
  const { id } = useParams();

  axios.defaults.baseURL = id;

  const user = useSelector((state) => state.user.data);

  const phone = user?.phone;
  const email = user?.email;
  const username = user?.username;
  const studid = user?.stud_id;

  const [fullname, setfullname] = useState("_");

  useEffect(() => {
    setTimeout(function () {
      setfullname(username ? username.split(" ")[0] : '_');
    }, 6000);

    localStorage.setItem("id", studid);

  }, [username, studid]);

  const [list, setList] = useState(null);

  const [news, setNews] = useState([]);

  const FetchNews = () => {
    axios({
      method: "post",
      url: "./v3/news/",
      data: {
        studid,
      },
      config: { headers: { "Content-Type": "multiport/form-data" } },
    })
      .then(function (response) {
        const view = response.data;

        setNews(view);

      })
      .catch((err) => {
        // toast.error("Error: Request Failed! Refresh page..");
      });
  };

  useEffect(() => {
    FetchNews();
  }, [studid]);

  const [statuss, setStat] = useState(false);


  return (
    <div>

      <Header />

      <Sidebar />

      <div class="docs-wrapper">
        <div class="container-fluid px-3 px-lg-8 pt-lg-14 pt-4">

          {statuss ?
            <div>
              <div className="row">

                <div className="col-6 mb-6 text-start">
                  <div className="fs-3 text-purple2">
                    Welcome Back <span className="fw-medium">{fullname}!</span>
                  </div>
                </div>

                <div className="col-6 mb-6 text-end">
                  <div className="fs-3 text-purple2">
                    Dashboard |{" "}
                    <span className="text-dark fs-5">
                      ---- Home
                    </span>
                  </div>
                </div>
              </div>

              <div className="row px-1">

                <div className="col-lg-7 mb-6">
                  <div className="card py-6 px-6 shadow-none bg-green mb-4" style={{ borderRadius: "25px" }}>
                    <div className="row align-items-center placeholder-glow">
                      <div className="text-white fs-3 col-10">
                        <i class="bi bi-controller"></i> Play Quiz Game.
                      </div>
                      <Link to={"../" + id + "/games/invites"} className="col-2">
                        <div className="btn btn-white rounded-circle">
                          <i class="bi bi-arrow-right fs-3"></i>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="card py-6 px-6 shadow-none bg-success mb-4" style={{ borderRadius: "25px" }}>
                    <div className="row align-items-center">
                      <div className="text-white fs-3 col-10">
                        <i class="bi bi-gift"></i> Play Treasure Hunt Game.
                      </div>
                      <Link to={"../" + id + "/games/treasure-hunt"} className="col-2">
                        <div className="btn btn-white rounded-circle">
                          <i class="bi bi-arrow-right fs-3"></i>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="card py-6 px-6 shadow-none bg-dark opacity-75" style={{ borderRadius: "25px" }}>
                    <div className="row align-items-center">
                      <div className="text-white fs-3 col-10">
                        <i class="bi bi-bell"></i> School News.
                      </div>
                      <div className="col-2">

                        {isMobile ? (
                          <div
                            className="btn btn-white rounded-circle"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasBottom"
                            aria-controls="offcanvasBottom"
                          >
                            <i class="bi bi-arrow-right fs-3"></i>
                          </div>
                        ) : (
                          <div
                            className="btn btn-white rounded-circle"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight"
                          >
                            <i class="bi bi-arrow-right fs-3"></i>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 mb-6">
                  <div className="card py-4 shadow-none px-6" style={{ borderRadius: "25px" }}>

                    <div className="text-purple2 fs-3 mb-3">
                      <i class="bi bi-graph-up-arrow"></i> Last Exam Percentage
                    </div>
                    <Statistic />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="card py-lg-4 px-lg-6 py-4 px-3 shadow-none" style={{ borderRadius: "25px" }}>
                    <div className="row align-items-center mb-4 mt-2 px-2">
                      <div className="col-8 text-purple2 fs-3 fw-medium">Recent Tasks
                      </div>

                      <div className="col-4 text-end">
                        <div class="btn btn-purple fs-3 text-white btn-lg rounded-circle">
                          <i class="bi bi-arrow-return-right"></i>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      {list ?
                        <div className="col-12 text-center">
                          <img
                            src="../assets/images/background/13-dark.png"
                            width={isMobile ? '80%' : '32%'}
                            alt=""
                          />

                          <div className="fs-3 text-purple3 mt-2">
                            Looks like you need to perform a task. Tasks list is empty!
                          </div>
                        </div>
                        :
                        <>
                          <div className="col-12 col-lg-6 mt-4">
                            <div className="card bg-purple4 opacity-75 rounded-pill shadow-none">
                              <div className="py-3 px-3">
                                <div className="row align-items-center">
                                  <div className="col-2">
                                    <button className="btn btn-white text-dark btn-md fs-3 rounded-circle">
                                      <i class="bi bi-disc"></i>
                                    </button>
                                  </div>

                                  <div className="col-8">
                                    <div className="fs-4 text-white">
                                      Mathematics Week 1
                                    </div>
                                    <div className="fs-5 text-white">
                                      Classwork
                                    </div>
                                  </div>

                                  <div className="col-2">
                                    <i class="bi bi-arrow-right fs-3 text-white"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-lg-6 mt-4">
                            <div className="card bg-orange_ opacity-75 rounded-pill shadow-none">
                              <div className="py-3 px-3">
                                <div className="row align-items-center">
                                  <div className="col-2">
                                    <button className="btn btn-white text-dark btn-md fs-3 rounded-circle">
                                      <i class="bi bi-disc"></i>
                                    </button>
                                  </div>

                                  <div className="col-8">
                                    <div className="fs-4 text-white">
                                      Mathematics Week 1
                                    </div>
                                    <div className="fs-5 text-white">
                                      Homework
                                    </div>
                                  </div>

                                  <div className="col-2">
                                    <i class="bi bi-arrow-right fs-3 text-white"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-lg-6 mt-4">
                            <div className="card bg-purple3 opacity-75 rounded-pill shadow-none">
                              <div className="py-3 px-3">
                                <div className="row align-items-center">
                                  <div className="col-2">
                                    <button className="btn btn-white text-dark btn-md fs-3 rounded-circle">
                                      <i class="bi bi-disc"></i>
                                    </button>
                                  </div>

                                  <div className="col-8">
                                    <div className="fs-4 text-white">
                                      Mathematics Week 1
                                    </div>
                                    <div className="fs-5 text-white">
                                      Lecture
                                    </div>
                                  </div>

                                  <div className="col-2">
                                    <i class="bi bi-arrow-right fs-3 text-white"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-lg-6 mt-4">
                            <div className="card bg-dark opacity-75 rounded-pill shadow-none">
                              <div className="py-3 px-3">
                                <div className="row align-items-center">
                                  <div className="col-2">
                                    <button className="btn btn-white text-dark btn-md fs-3 rounded-circle">
                                      <i class="bi bi-disc"></i>
                                    </button>
                                  </div>

                                  <div className="col-8">
                                    <div className="fs-4 text-white">
                                      Alex Chemistry Test
                                    </div>
                                    <div className="fs-5 text-white">
                                      Quiz Game
                                    </div>
                                  </div>

                                  <div className="col-2">
                                    <i class="bi bi-arrow-right fs-3 text-white"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                </div>

              </div>
            </div>
            :
            <>
              <div className="row">
                <div className="col-12">
                  <div className="card bg-white p-6 shadow-none text-center" style={{ borderRadius: "25px" }}>
                    <div className="text-center">
                    <img
                      src="../assets/images/background/build.jpg"
                      width={isMobile ? '100%' : '30%'}
                      alt=""
                    />
                    </div>

                    <div className="col-12 mt-4">
                      <div className="text-purple2 fs-3 fw-medium">
                        Cooking up something for you!
                      </div>
                      <div className="fs-4 text-purple2 mt-2">
                         Dashboard would be fully ready soon! Click on the button below to view result.
                      </div>

                      <div className="mt-4">
                        <Link to={"../" + id + "/result"} className="btn btn-purple btn-lg text-white rounded-4 fwt">
                          <i class="bi bi-arrow-return-right"></i> View Result
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }

          <Footer />
        </div>
      </div>


      {isMobile ? (
        <div
          class="offcanvas offcanvas-bottom offcanvas-lg bg-white"
          tabindex="-1"
          id="offcanvasBottom"
          aria-labelledby="offcanvasBottomLabel"
          style={{
            height: "750px",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        >
          <div class="offcanvas-header">
            <div
              class="offcanvas-title fs-t2 text-q2"
              id="offcanvasBottomLabel"
            ></div>

            <button
              class="btn btn-white btn-icon text-purple2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i class="bi bi-x-lg fw-bold fs-t"></i>
            </button>
          </div>
          <div class="offcanvas-body py-0 px-4">

            <div className="card py-5 px-6 bg-purple shadow-none" style={{ borderRadius: "25px" }}>
              <div className="row align-items-center">
                <div className="col-6 text-end ms-n6 mt-n4">
                  <img
                    src="../assets/images/background/13.png"
                    width='100%'
                    alt=""
                  />
                </div>
                <div className="col-12 text-end fs-t2 text-white mt-n6 fw-medium">
                  School News
                </div>
              </div>
            </div>

            <div className="card py-4 px-1 bg-white shadow-none" style={{ borderRadius: "25px" }}>
              <div className="fs-s3 text-purple2 lh-0">
                {news.story}
              </div>


              <div class="d-flex align-items-start pt-1 mt-4">
                <img src="../assets/images/avatar/avatar-2.jpg" alt="" class="rounded-circle avatar-lg" />
                <div class="ms-3">
                  <div class="fs-s3 mb-1">
                    {news.author}
                    <span class="ms-2 fs-6">{news.date}</span>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      ) : (
        <>
          <div
            class="offcanvas offcanvas-end bg-white"
            tabindex="-1"
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
            style={{ width: '400px' }}
          >
            <div class="offcanvas-header">
              <div
                class="offcanvas-title fs-t2 text-q2"
                id="offcanvasBottomLabel"
              ></div>

              <button
                class="btn btn-white btn-icon text-purple3"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <i class="bi bi-x-lg fw-bold fs-t"></i>
              </button>
            </div>

            <div class="offcanvas-body py-0 px-4">

              <div className="card py-3 px-6 bg-purple opacity-75 shadow-none" style={{ borderRadius: "25px" }}>
                <div className="row align-items-center">
                  <div className="col-6 text-end ms-n6 mt-n4">
                    <img className="opacity-100"
                      src="../assets/images/background/13.png"
                      width='100%'
                      alt=""
                    />
                  </div>
                  <div className="col-12 text-end fs-t2 text-white mt-n6 fw-medium">
                    School News
                  </div>
                </div>
              </div>

              <div className="card py-4 px-4 bg-white shadow-none" style={{ borderRadius: "25px" }}>
                <div className="fs-4 text-purple2 lh-0">
                  {news.story}
                </div>


                <div class="d-flex align-items-start pt-1 mt-4">
                  <img src="../assets/images/avatar/avatar-2.jpg" alt="" class="rounded-circle avatar-lg" />
                  <div class="ms-3">
                    <div class="fs-s3 mb-1">
                      {news.author}
                      <span class="ms-2 fs-6">{news.date}</span>
                    </div>
                  </div>
                </div>

              </div>


            </div>


          </div>
        </>
      )}

    </div>
  );
};

export default Home;
